import { shallowRef } from 'vue';
import { assertOk, errorMessage } from '@/api/http';
import { useToast } from './useToast';

// Runs a request with a busy flag and a toast either way, so pages don't
// repeat try/catch/finally around every save or delete.
//   const { busy, run } = useAsyncAction();
//   await run(() => apiRequest('post', '/x', data), {
//     success: 'Saved.', error: 'Could not save.' });   // → true on success
export function useAsyncAction() {
  const toast = useToast();
  const busy = shallowRef(false);

  async function run(request, { success = '', error = 'Something went wrong. Please try again.' } = {}) {
    busy.value = true;
    try {
      assertOk(await request());
      if (success) toast.success(success);
      return true;
    } catch (e) {
      toast.error(errorMessage(e, error));
      return false;
    } finally {
      busy.value = false;
    }
  }

  return { busy, run };
}
